/**
 * 通知类型枚举
 */

export enum NotificationType {
  CRM_RECORD_NEW = 'crm_record_new',
  CRM_RECORD_ASSIGNED = 'crm_record_assigned',
  CRM_RECORD_RETURNED_POOL = 'crm_record_returned_pool',
  CRM_RECORD_TRANSFERRED_POOL = 'crm_record_transferred_pool',
  CRM_RECORD_DEAL = 'crm_record_deal',
  CRM_FOLLOW_UP_REMINDER = 'crm_follow_up_reminder',
  CRM_FOLLOW_UP_REPORT = 'crm_follow_up_report',
  SYSTEM_ANNOUNCEMENT = 'system_announcement',
}

/** 通知类型展示标签 */
export const NOTIFICATION_TYPE_LABEL: Record<NotificationType, string> = {
  [NotificationType.CRM_RECORD_NEW]: '新客资',
  [NotificationType.CRM_RECORD_ASSIGNED]: '客资分配',
  [NotificationType.CRM_RECORD_RETURNED_POOL]: '客资退回公海',
  [NotificationType.CRM_RECORD_TRANSFERRED_POOL]: '客资转移',
  [NotificationType.CRM_RECORD_DEAL]: '客资成交',
  [NotificationType.CRM_FOLLOW_UP_REMINDER]: '下次跟进提醒',
  [NotificationType.CRM_FOLLOW_UP_REPORT]: '跟进工作汇报',
  [NotificationType.SYSTEM_ANNOUNCEMENT]: '系统公告',
};

/** 通知保留天数（TTL 索引） */
export const NOTIFICATION_TTL_DAYS = 90;
